var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 145,
    viewBox: "0 0 1440 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4168_651)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4168_651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.776 82.8087C797.482 104.681 777.885 120.543 756.012 118.248C734.14 115.954 718.278 96.357 720.572 74.4844L740.378 76.5702C739.231 87.5017 747.166 97.3051 758.098 98.4523C769.03 99.5994 778.833 91.6639 779.98 80.7323L799.786 82.8181L799.776 82.8087Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.182 27.563C262.063 33.3464 233.412 71.3651 239.195 112.484L313.649 102.017L303.182 27.563Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2822 90.2416C42.8255 117.139 74.7953 128.772 101.683 116.229L78.9765 67.5347L30.2822 90.2416Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.14 -74.5376C1074.21 -73.9593 1083.66 -82.4637 1084.23 -93.5375C1084.81 -104.611 1076.31 -114.054 1065.23 -114.633C1069.28 -191.855 1059.09 2.67538 1063.13 -74.5376H1063.14Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.08 39.0263C1268.19 33.4799 1293.86 50.138 1299.4 76.2486C1304.95 102.359 1288.29 128.024 1262.18 133.57C1236.07 139.117 1210.41 122.459 1204.86 96.3482C1199.31 70.2376 1215.97 44.5726 1242.08 39.0263ZM1247.1 62.6623C1234.04 65.4403 1225.71 78.268 1228.49 91.3233C1231.26 104.379 1244.09 112.712 1257.15 109.934C1270.2 107.156 1278.54 94.3287 1275.76 81.2734C1272.98 68.2182 1260.15 59.8844 1247.1 62.6623Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.55 12.6505C599.709 -0.888342 580.757 -3.89382 567.218 5.94743C553.679 15.7887 550.674 34.7411 560.515 48.2799C466.075 116.894 703.99 -55.9633 609.55 12.6505Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.979 -6.82356C968.528 8.19429 993.311 7.75816 1008.33 -7.79062C1023.35 -23.3394 1022.91 -48.1226 1007.36 -63.1405C991.813 -78.1583 967.03 -77.7222 952.012 -62.1734C936.994 -46.6247 937.431 -21.8414 952.979 -6.82356Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.17 54.442C1136.52 66.5871 1140.73 90.4981 1128.59 107.848C1116.44 125.198 1092.53 129.408 1075.18 117.263C1057.83 105.118 1053.62 81.2067 1065.76 63.8566C1077.91 46.5064 1101.82 42.2969 1119.17 54.442ZM1108.17 70.1424C1099.5 64.0651 1087.54 66.1794 1081.47 74.8545C1075.41 83.5296 1077.51 95.4851 1086.19 101.553C1094.86 107.621 1106.82 105.516 1112.89 96.8408C1118.95 88.1658 1116.85 76.2103 1108.17 70.1424Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.222 40.4574C455.437 59.3435 447.587 82.1262 428.701 91.3417C409.815 100.557 387.032 92.707 377.816 73.8209C368.601 54.9348 376.451 32.152 395.337 22.9365C414.223 13.721 437.006 21.5713 446.222 40.4574ZM429.118 48.8006C424.51 39.3576 413.124 35.4325 403.68 40.0402C394.237 44.648 390.312 56.0346 394.92 65.4777C399.528 74.9207 410.914 78.8458 420.358 74.2381C429.801 69.6303 433.726 58.2437 429.118 48.8006Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.889 53.4187C981.147 95.9029 953.396 137.041 910.912 145.299L903.432 106.834C924.678 102.701 938.549 82.1365 934.415 60.8896L972.88 53.4092L972.889 53.4187Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.615 2.68595C819.696 -23.9556 857.563 -29.2839 884.204 -9.20319L866.029 14.9164C852.708 4.87605 833.765 7.54019 823.735 20.8609L799.615 2.68595Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.72 132.129C1383.45 143.516 1408.68 136.756 1420.08 117.026C1431.46 97.2963 1424.7 72.0674 1404.97 60.6713C1385.24 49.2752 1360.02 56.0446 1348.62 75.7745C1337.23 95.5043 1343.99 120.733 1363.72 132.129Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.819 -14.6269C497.864 -19.1209 512.086 -12.1808 516.58 0.864993C521.074 13.9108 514.134 28.1322 501.088 32.6262C488.042 37.1202 473.821 30.1801 469.327 17.1343C464.833 4.08853 471.773 -10.1329 484.819 -14.6269ZM488.886 -2.81361C482.363 -0.566623 478.893 6.54412 481.14 13.067C483.387 19.5899 490.498 23.0599 497.021 20.813C503.544 18.566 507.014 11.4552 504.767 4.93234C502.52 -1.59057 495.409 -5.0606 488.886 -2.81361Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.07 15.1344C1115.8 6.44981 1117.46 -9.28859 1108.77 -20.0116C1100.09 -30.7345 1084.35 -32.3937 1073.62 -23.7091C1062.9 -15.0246 1061.24 0.713835 1069.93 11.4368C1078.61 22.1598 1094.35 23.8189 1105.07 15.1344Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.905 48.8384C146.671 36.589 149.117 19.163 161.376 9.93798C173.625 0.703525 191.042 3.1496 200.276 15.4085C209.511 27.6579 207.065 45.0839 194.806 54.3089C182.556 63.5434 165.14 61.0973 155.905 48.8384ZM166.998 40.4762C171.615 46.6009 180.328 47.8239 186.453 43.2067C192.578 38.5895 193.801 29.8765 189.183 23.7518C184.566 17.6271 175.853 16.404 169.729 21.0212C163.604 25.6385 162.381 34.3515 166.998 40.4762Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.84 -12.3889C1253.65 -36.2904 1284.21 -44.4819 1308.11 -30.6777L1295.61 -9.0421C1283.66 -15.9442 1268.38 -11.8485 1261.48 0.10703L1239.84 -12.3889Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.629 121.814C151.089 135.723 163.547 145.811 177.455 144.351C191.364 142.89 201.452 130.432 199.992 116.524C198.532 102.615 186.074 92.5276 172.165 93.9876C158.256 95.4477 148.169 107.906 149.629 121.814Z",
    fill: "#2D38AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3858 -10.3604C42.5219 -2.51959 47.6322 15.2951 39.8009 29.4313C31.9601 43.5674 14.1454 48.6776 0.00927734 40.8463L7.10104 28.047C14.1738 31.9627 23.0859 29.4123 27.0016 22.3395C30.9172 15.2667 28.3668 6.36407 21.294 2.43895L28.3953 -10.3604H28.3858Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.997 -28.838C352.19 -26.4962 348.568 -19.0727 350.91 -12.2559C353.251 -5.43904 360.675 -1.82678 367.492 -4.16857C383.856 43.3405 342.642 -76.3472 358.997 -28.838Z",
    fill: "#FFC846"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4168_651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 145,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4168_651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2730.61,
    height: 389.298,
    fill: "white",
    transform: "translate(0 -244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.b18d027b22189483e817d31f429b2010.svg";
export { ForwardRef as ReactComponent };